import {
  hideHeader,
  Modal,
  NavigationConfig,
  registerNavigationHandlers,
} from '@bonanza-social/navigation';
import DetailsAttestationScreen from '../screens/DetailsAttestationScreen';

export const NAVIGATION_CONFIG: NavigationConfig<AppNavigatorParamsList> = {
  FULL_SCREENS: [],
  FULL_SCREEN_MODALS: [
    {
      name: 'DetailsAttestation',
      options: hideHeader,
      component: DetailsAttestationScreen,
    },
  ],
  FULL_SCREEN_MODALS_TRANSPARENT: [],
};

registerNavigationHandlers<AppNavigatorParamsList, 'DetailsAttestation'>({
  DetailsAttestation() {
    Modal.open({
      namespace: 'detailsAttestation',
      type: 'DetailsAttestation',
      canClose: false,
      options: {
        hideHeader: true,
      },
    });
  },
});
